import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { StateWithTracking, TRACKING_FEATURE, TrackingState } from '../tracking-state';

export const getTrackingState: MemoizedSelector<StateWithTracking, TrackingState> =
  createFeatureSelector<TrackingState>(TRACKING_FEATURE);
